module.exports = __webpack_public_path__ + "img/reservations.21d7b80.svg";